import { render } from "./ParcelLocationList.vue?vue&type=template&id=fb1f7274"
import script from "./ParcelLocationList.vue?vue&type=script&lang=js"
export * from "./ParcelLocationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__